<template>
	<div class="joboffer-search">
		<h2 class="content-block">Job Offer Search</h2>
		<div class="content-block">
			<DxBox>
				<DxItem :ratio="1">
					<DxSelectBox label="Type" :data-source="jobTypes" :search-enabled="true" />
				</DxItem>
				<DxItem :ratio="1">
					<DxSelectBox label="Country" :data-source="countryTypes" :search-enabled="true" />
				</DxItem>
				<DxItem :ratio="1">
					<DxTextBox label="Region" />
				</DxItem>
			</DxBox>
			<DxList :data-source="jobOffersSource" :search-enabled="true" :search-timeout="700" @item-click="onItemClick">
				<template #item="{ data: item }">
					<div class="dx-card">
						<div v-if="!expandItems.includes(item.id)" class="joboffer-teaser">
							<div class="joboffer-teaser-logo">
								<img src="https://www.google.com/images/branding/googlelogo/1x/googlelogo_color_272x92dp.png" alt="Google Logo" />
							</div>
							<div>
								<div class="joboffer-teaser-title">{{ item.title }}</div>
								<div class="joboffer-teaser-details">
									<i class="dx-icon dx-icon-box" /><div>{{ item.type }}</div>
									<i class="dx-icon dx-icon-clock" /><div>{{ item.hours }}</div>
									<i class="dx-icon dx-icon-money" /><div>{{ item.salary }}</div>
								</div>
							</div>
						</div>
						<div v-else>
							{{  item }}
						</div>
					</div>
				</template>
			</DxList>
		</div>
	</div>
</template>

<script setup>
/* eslint-disable */
import auth from "../auth";
import { onMounted, inject, ref } from 'vue'
import { DxBox, DxItem } from 'devextreme-vue/box';
import { DxList } from 'devextreme-vue/list';
import { DxTextBox } from 'devextreme-vue/text-box';
import { DxSelectBox } from 'devextreme-vue/select-box';
import CustomStore from 'devextreme/data/custom_store';
import notify from 'devextreme/ui/notify';
const $http = inject('$http');

const expandItems = ref([]);			// Array of job offer ids to expand in list.

// Handle item click on job offers to expand fully.
const onItemClick = (e) => {
	if (expandItems.value.includes(e.itemData.id))
		expandItems.value.splice(expandItems.value.indexOf(e.itemData.id), 1);
	else
		expandItems.value.push(e.itemData.id);
}

const jobTypes = ['ICU Nurse', 'General Nurse', 'Midwife', 'Nurse Practitioner', 'Nurse Manager', 'Nurse Educator', 'Nurse Administrator', 'Nurse Consultant', 'Nurse Researcher'];
const countryTypes = ['Portugal', 'Spain', 'France', 'Italy', 'Germany', 'United Kingdom', 'United States', 'Canada', 'Australia', 'New Zealand'];

const jobOffersSource = new CustomStore({
	load: (loadOptions) => {
		console.log(loadOptions);
        return fetchJobOffers();
    },
 
    byKey: (key) => {
        return fetchJobOffers().filter(j => j.id == key);
    },
 
    insert: (values) => {
        console.log(values);
    },
 
    update: (key, values) => {
        console.log(key, values);
    },
 
    remove: (key) => {
        console.log(key);
    },
});

const fetchJobOffers = () => {
	return [
		{
			id: 1,
			uuid: 'uuid-uuid-uuid',
			title: 'Job Offer 1',
			type: 'ICU Nurse',
			hours: 'fulltime',
			salary: 'USD 1000/month',
			responsibilities: 'Responsibilities 1',
			requirements: 'Requirements 1',
			description: 'Description 1',
			website: 'https://www.google.com',
			telephone: '+351 911 222 333',
			email: 'info@google.com',
			address: '123 Main St, Anytown, USA',
			region: 'Anytown',
			country: 'USA',
			company_id: 1,
			updated_at: '2024-01-01 00:00:00',
			created_at: '2024-01-01 00:00:00',
		},
		{
			id: 2,
			uuid: 'uuid-uuid-uuid',
			title: 'Job Offer 2',
			type: 'ICU Nurse',
			hours: 'fulltime',
			salary: 'USD 1000/month',
			responsibilities: 'Responsibilities 1',
			requirements: 'Requirements 1',
			description: 'Description 1',
			website: 'https://www.google.com',
			telephone: '+351 911 222 333',
			email: 'info@google.com',
			address: '123 Main St, Anytown, USA',
			region: 'Anytown',
			country: 'USA',
			company_id: 1,
			updated_at: '2024-01-01 00:00:00',
			created_at: '2024-01-01 00:00:00',
		},
		{
			id: 3,
			uuid: 'uuid-uuid-uuid',
			title: 'Job Offer 3',
			type: 'ICU Nurse',
			hours: 'fulltime',
			salary: 'USD 1000/month',
			responsibilities: 'Responsibilities 1',
			requirements: 'Requirements 1',
			description: 'Description 1',
			website: 'https://www.google.com',
			telephone: '+351 911 222 333',
			email: 'info@google.com',
			address: '123 Main St, Anytown, USA',
			region: 'Anytown',
			country: 'USA',
			company_id: 1,
			updated_at: '2024-01-01 00:00:00',
			created_at: '2024-01-01 00:00:00',
		},
	];
}

onMounted(() => {
});
</script>

<style lang="scss">
@import "../themes/generated/variables.base.scss";
.joboffer-search {
	.dx-list-item.dx-item {
		margin-bottom: 1em;
	}
	.joboffer-teaser {
		display: flex;
		flex-direction: row;
		gap: 1.5em;
	}
	.joboffer-teaser-logo img {
		width: 100px;
		height: 100px;
		object-fit: scale-down;
		outline: 1px solid #5553;
		padding: 5px;
	}
	.joboffer-teaser-title {
		font-size: 24px;
		font-weight: bold;
		margin-bottom: 0.5em;
		margin-top: 0.5em;
	}
	.joboffer-teaser-details {
		display: flex;
		flex-direction: row;
		align-items: center;
		gap: 0.5em;
	}
	.joboffer-teaser-details > div {
		line-height: 24px;
	}
}
</style>
